export function scrollToSingleBody() {
  // ハッシュが既にある場合はそちらを優先
  if (window.location.hash) return;

  const target = document.getElementById("single-body");
  if (!target) return;

  window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY);
}
